import { PublicKey } from '@solana/web3.js';
export const KYCDAO_COLLECTION_KYC_SEED = 'KYCDAO_COLLECTION_KYC_SEED';
export const KYCDAO_STATUS_KYC_SEED = 'KYCDAO_STATUS_KYC_SEED';
export const TOKEN_METADATA_PROGRAM_ID = new PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
export const TOKEN_PROGRAM_ID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
//# sourceMappingURL=constants.js.map